// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import Input from 'components/Input';
import { ClearButton } from 'components/Button';
import { matchSize } from 'utils/responsive';

const SearchQueryInput = styled(
  ({ showClearButton, ...props }: { showClearButton: boolean }) => (
    <Input {...props} />
  )
)`
  width: 100%;
  border-radius: 0;
  ${props =>
    props.showClearButton &&
    css`
      padding-right: 38px;
    `}
`;

const InputContainer = styled.div`
  display: inline-flex;
  position: relative;
  align-items: center;
  width: 100%;
`;

type Props = {
  query: string,
  className?: string,
  placeholder?: string,
  xsPlaceholder?: string,
  onChange: any => void,
  clearQuery: () => void,
  'data-qa-id'?: string
};

type State = {
  showClearButton: boolean
};

class SearchQueryInputContainer extends React.Component<Props, State> {
  state = {
    showClearButton: this.props.query !== ''
  };

  componentWillReceiveProps(newProps: Props) {
    this.setState({ showClearButton: newProps.query !== '' });
  }

  render() {
    return (
      <InputContainer className={this.props.className}>
        <SearchQueryInput
          placeholder={
            matchSize({ xs: true })
              ? this.props.xsPlaceholder
              : this.props.placeholder
          }
          value={this.props.query}
          onChange={this.props.onChange}
          showClearButton={this.state.showClearButton}
          data-qa-id={this.props['data-qa-id']}
          aria-label={this.props.placeholder}
        />
        {this.state.showClearButton && (
          <ClearButton
            onClick={this.props.clearQuery}
            data-qa-id="search-input-clear"
            aria-label={getText('Clear search input')}
          />
        )}
      </InputContainer>
    );
  }
}

export default SearchQueryInputContainer;
